<input
  [value]="data.value"
  [readonly]="data.readonly"
  [type]="data.type"
  (input)="onChange($event)"
/>
